/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { constraint_item_types } from './constraint_item_types';
import type { constraint_modifier_condition_full } from './constraint_modifier_condition_full';
import type { constraint_modifier_repeater_full } from './constraint_modifier_repeater_full';
export type constraint_modifier_full = {
  name: string;
  action: constraint_modifier_full.action;
  field: constraint_modifier_full.field;
  value: string;
  child_id: string | null;
  child_type: constraint_item_types | null;
  conditions: Array<constraint_modifier_condition_full>;
  repeats: Array<constraint_modifier_repeater_full>;
};
export namespace constraint_modifier_full {
  export enum action {
    INCREMENT = 'Increment',
    SET = 'Set',
    APPEND = 'Append',
    DECREMENT = 'Decrement',
  }
  export enum field {
    POINT = 'Point',
    HIDDEN = 'Hidden',
    NAME = 'Name',
    CONSTRAINT = 'Constraint',
  }
}
